import { RestResponse } from "@/business/shared/commons/rest/RestResponse";
import { restClient } from "@/business/shared/commons/rest/restClient";
import { errorManagerActions } from "@/business/shared/commons/rest/errorManagerActions";
import { getDeliveryById } from "../constants/urls";
import { getEnvVariable } from "@/business/shared/commons/envUtils/getEnvVariable";
import { Delivery, DeliveryActions } from "../../domain/deliveries";

export const getDeliveryByIdService = {
  async execute(id: string): Promise<Delivery> {
    const url = getEnvVariable
      .execute("VUE_APP_SUBSCRIPTION_UB_URL")
      .concat(getDeliveryById)
      .replace("{deliveryId}", id);

    const response: RestResponse = await restClient().sendRequest(url, "GET");

    // if (!response.isSuccess) {
    //   throw errorManagerActions().transformBC(response.content);
    // }

    return DeliveryActions().deserializeObject(response.content);
  },
};
